import { useEffect, useState } from "react";
import { Globe } from "lucide-react";
import { useCurrency, CURRENCIES } from "@/context/CurrencyContext";
import { LANGS, readLangCookie, applyLanguage } from "@/lib/translate";

export const LangCurrencyControls = () => {
  const { currency, setCurrency } = useCurrency();
  const [lang, setLang] = useState("en");

  useEffect(() => { setLang(readLangCookie()); }, []);

  const onLang = (e) => {
    const code = e.target.value;
    setLang(code);
    applyLanguage(code);
  };

  return (
    <div className="flex items-center gap-2 notranslate" translate="no" data-testid="lang-currency-controls">
      <div className="flex items-center gap-1 text-[#8A8175]" title="Translate this site">
        <Globe className="h-4 w-4" />
        <select
          data-testid="language-select"
          value={lang}
          onChange={onLang}
          aria-label="Select language"
          className="text-[12px] bg-transparent border border-[#D9CBA0]/60 rounded-full px-2 py-1 text-[#3A3632] focus:outline-none focus:border-[#8E9A86] cursor-pointer">
          {LANGS.map((l) => (
            <option key={l.code} value={l.code}>{l.label}</option>
          ))}
        </select>
      </div>
      <select
        data-testid="currency-select"
        value={currency}
        onChange={(e) => setCurrency(e.target.value)}
        aria-label="Display currency"
        className="text-[12px] bg-transparent border border-[#D9CBA0]/60 rounded-full px-2 py-1 text-[#3A3632] focus:outline-none focus:border-[#8E9A86] cursor-pointer">
        {CURRENCIES.map((c) => (
          <option key={c.code} value={c.code}>{c.code}</option>
        ))}
      </select>
    </div>
  );
};
